module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.fb49d74b.svg";